// src/LanguageTranslationService.js
import { translations } from '../language/StatsTranslations';
import { locationTranslations } from '../language/LocationTranslations_v1';
import { headerTranslations } from '../language/HeaderTranslations';
import { ApplicantLoginTranslations } from '../language/ApplicantLoginTranslation';
import { ForgotPasswordTranslations } from '../language/ForgotPasswordTranslation';
import { OfficeLoginTranslations } from '../language/OfficeLoginTranslation';
import { ApplicantRegistrationTranslations } from '../language/ApplicantRegistrationTranslation';
import { HomeTranslations } from '../language/HomeTranslations';
import { ContactTranslations } from '../language/ContactTranslation';
// Get the user's language preference
const getLanguage = () => {
  const savedLang = localStorage.getItem('preferredLanguage');
  if (savedLang) return savedLang;
  
  const browserLang = navigator.language.split('-')[0];
  if (translations[browserLang]) return browserLang;
  
  return 'en';
};

const currentLanguage = getLanguage();

// Main translation function
const t = (key) => {
  const keys = key.split('.');
  let value = translations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};

// Location translation function
const translateLocation = (type, name) => {
  return locationTranslations[currentLanguage]?.[type]?.[name] || name;
};

// Header translation function
const tHeader = (key) => {
  const keys = key.split('.');
  let value = headerTranslations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};

// ApplicantLoginTranslations  translation function
const ApplicantLoginT = (key) => {
  const keys = key.split('.');
  let value = ApplicantLoginTranslations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};


// ForgotPasswordTranslations  translation function
const ForgotPasswordT = (key) => {
  const keys = key.split('.');
  let value = ForgotPasswordTranslations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};



// OfficeLoginTranslations  translation function
const OfficeLoginT = (key) => {
  const keys = key.split('.');
  let value = OfficeLoginTranslations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};

// ApplicantRegistrationTranslations  translation function
const ApplicantRegistrationT = (key) => {
  const keys = key.split('.');
  let value = ApplicantRegistrationTranslations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};

// HomeTranslations  translation function
const HomeT = (key) => {
  const keys = key.split('.');
  let value = HomeTranslations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};

// ContactTranslations  translation function
const ContactT = (key) => {
  const keys = key.split('.');
  let value = ContactTranslations[currentLanguage];
  
  for (const k of keys) {
    if (value && value.hasOwnProperty(k)) {
      value = value[k];
    } else {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
  }
  
  return value;
};


const setLanguage = (lang) => {
  if (translations[lang]) {
    localStorage.setItem('preferredLanguage', lang);
    window.location.reload();
  }
};

export { tHeader, t, translateLocation, ContactT, HomeT, ApplicantRegistrationT, ApplicantLoginT, OfficeLoginT, ForgotPasswordT, setLanguage, currentLanguage };